/*
 * FPD → Offert-Brücke
 *
 * Produktseite: setzt einen "Begär offert"-Button neben "Done" in die
 * Aktionsleiste des Designer-Modals. Ein Klick liest das Produkt, die Mengen
 * aus dem Bulk-Order-Modul und das Vorschaubild des Designs und öffnet
 * /pages/offert mit diesen Daten.
 *
 * Offert-Seite: holt das Vorschaubild aus dem sessionStorage und reicht es an
 * den Datei-Upload der Zeile "Enligt mockup (alla tryck)" weiter. Dort lädt
 * das Offert-Script es wie eine vom Kunden gewählte Datei hoch.
 *
 * Ist das Bulk-Order-Modul im Designer, sind "Done" und "Begär offert" gesperrt,
 * solange in der Größentabelle keine Menge steht; über der Tabelle steht dann
 * ein Hinweis. Die Mengen kommen aus dem Modul-State der Produktseite, nicht
 * aus dem DOM - das Raster zeigt nur die Größen der gerade gewählten Farbe.
 *
 * Gespeicherte Designs: Beim Bestellen (Done, Warenkorb-Button) und bei "Begär offert"
 * landet das Design automatisch im Save-Load-Modul des Designers (Browser-Speicher,
 * derselbe Eintrag wie über dessen Speichern-Button). Gibt es gespeicherte Designs,
 * öffnet der Designer beim Laden einer Produktseite dieses Modul statt des Startmoduls;
 * nach dem Laden eines Designs geht es zurück zum Startmodul (Größentabelle).
 *
 * Einbinden: in theme.liquid direkt vor </body>, damit es auf beiden Seiten läuft.
 * Das Aussehen des Buttons (.fpd-offert-btn, .is-busy während des Exports) liegt im Theme-CSS,
 * Sperre und Hinweis bringt das Script selbst mit (injectStyles).
 */
(function () {
  var OFFERT_PATH = '/pages/offert';
  var STORAGE_KEY = 'fpdOffertDesign';
  var MAX_AGE_MS = 60 * 60 * 1000;
  // sessionStorage fasst ~5 MB pro Origin; darüber wird das Bild als JPEG verkleinert
  var MAX_DATAURL_LENGTH = 4 * 1024 * 1024;
  var BUTTON_LABEL = 'Begär offert';
  var COLOR_OPTION = /^(färg|farg|color|colour|farbe)$/i;
  var SIZE_OPTION = /^(storlek|size|größe|grösse)$/i;
  var NO_SIZES_MESSAGE = 'Välj storlek och antal nedan för att kunna beställa.';
  var BLOCKED_CLASS = 'fpd-offert-blocked';
  var ACTION_BUTTONS = '.fpd-modal-product-designer fpd-actions-bar .fpd-done, .fpd-offert-btn';
  var SAVE_LOAD_MODULE = 'save-load';
  var THUMBNAIL_SIZE = 300;

  if (location.pathname.indexOf(OFFERT_PATH) === 0) {
    onReady(attachDesignToOffert);
  } else if (location.pathname.indexOf('/products/') !== -1) {
    onReady(watchDesignerModal);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------------- Produktseite ---------------- */

  function watchDesignerModal() {
    // Die Aktionsleiste entsteht erst beim Öffnen des Modals und wird bei einem
    // Variantenwechsel neu gebaut - deshalb beobachten statt einmal einsetzen.
    var observer = new MutationObserver(refreshModal);
    observer.observe(document.body, { childList: true, subtree: true });
    injectStyles();
    watchBulkOrderQuantities();
    watchOrderForAutoSave();
    // showSavedDesignsOnStart();
    refreshModal();
  }

  function refreshModal() {
    insertButton();
    updateSizeGate();
  }

  /* ---------------- Sperre ohne Größen ---------------- */

  function watchBulkOrderQuantities() {
    // Das Modul meldet eine Menge schon beim Tippen (input) und "Clear all" per
    // Klick; beides ändert keine Kinder-Knoten, die der Observer sähe.
    var later = function () { setTimeout(updateSizeGate, 0); };
    document.addEventListener('input', later, true);
    document.addEventListener('change', later, true);
    document.addEventListener('click', later, true);

    // Die Klasse nimmt Done den Zeiger; ein Klick, der trotzdem ankommt
    // (Tastatur, Script), wird hier vor dem Handler des Designers abgefangen.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest(ACTION_BUTTONS);
      if (btn && btn.classList.contains(BLOCKED_CLASS)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  }

  function updateSizeGate() {
    var module = document.querySelector('.fpd-modal-product-designer fpd-module-bulk-order');
    var blocked = Boolean(module) && !hasBulkQuantities();

    document.querySelectorAll(ACTION_BUTTONS).forEach(function (btn) {
      if (btn.classList.contains(BLOCKED_CLASS) === blocked) return;
      btn.classList.toggle(BLOCKED_CLASS, blocked);
      btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    });

    if (!module) return;
    var note = module.querySelector('.fpd-offert-size-note');
    if (!note) {
      var grid = module.querySelector('.fpd-grid-section');
      if (!grid) return;
      note = document.createElement('div');
      note.className = 'fpd-offert-size-note';
      note.textContent = NO_SIZES_MESSAGE;
      grid.parentNode.insertBefore(note, grid);
    }
    if (note.hidden === blocked) note.hidden = !blocked;
  }

  function hasBulkQuantities() {
    var state = window.FPD && FPD.productPage && FPD.productPage._bulkOrderModuleState;
    var quantities = (state && state.quantities) || {};
    return Object.keys(quantities).some(function (id) { return parseInt(quantities[id], 10) > 0; });
  }

  function injectStyles() {
    if (document.getElementById('fpd-offert-bridge-styles')) return;
    var style = document.createElement('style');
    style.id = 'fpd-offert-bridge-styles';
    style.textContent =
      '.' + BLOCKED_CLASS + '{opacity:.35!important;cursor:not-allowed!important;pointer-events:none!important}' +
      '.fpd-offert-size-note{margin:0 0 14px;padding:10px 12px;border-radius:6px;' +
      'background:#fff4f4;color:var(--fpd-red-color,#c62828);font-size:13px;line-height:1.4}' +
      '.fpd-offert-size-note[hidden]{display:none}';
    document.head.appendChild(style);
  }

  /* ---------------- Gespeicherte Designs ---------------- */

  function watchOrderForAutoSave() {
    // Done bestellt die Größentabelle; die Capture-Phase kommt vor dem Handler
    // des Designers, also bevor die Seite zum Warenkorb wechselt.
    document.addEventListener('click', function (e) {
      var done = e.target.closest && e.target.closest('.fpd-modal-product-designer fpd-actions-bar .fpd-done');
      if (done && !done.classList.contains(BLOCKED_CLASS)) autoSaveDesign();
    }, true);

    // Warenkorb-Button außerhalb des Designers (atc-operator des FPD)
    window.FPD = window.FPD || {};
    FPD.callbacks = FPD.callbacks || {};
    var previous = FPD.callbacks.beforeAddToCart;
    FPD.callbacks.beforeAddToCart = function (form) {
      autoSaveDesign();
      if (typeof previous === 'function') return previous.apply(this, arguments);
    };

    // Nach dem Laden eines gespeicherten Designs zurück zum Startmodul,
    // damit Größen und Mengen gleich wieder sichtbar sind
    document.addEventListener('click', function (e) {
      var item = e.target.closest && e.target.closest('fpd-module-save-load .fpd-item');
      if (!item || e.target.closest('.fpd-delete')) return;
      setTimeout(function () {
        var fpd = window.FPD && FPD.instance;
        var start = fpd && fpd.mainOptions.initialActiveModule;
        if (start && start !== SAVE_LOAD_MODULE && fpd.mainBar) fpd.mainBar.callModule(start);
      }, 0);
    });
  }

  /** Speichert das aktuelle Design wie der Speichern-Button des Save-Load-Moduls. */
  function autoSaveDesign() {
    try {
      var fpd = window.FPD && FPD.instance;
      var module = fpd && fpd['moduleInstance_' + SAVE_LOAD_MODULE];
      if (!module || !fpd.mainOptions.saveActionBrowserStorage) return;
      if (!fpd.viewInstances.some(function (v) { return v.fabricCanvas.isCustomized; })) return;

      var product = fpd.getProduct(fpd.mainOptions.saveOnlyEditableElements);
      if (!product) return;

      // dasselbe Design nicht bei jeder Bestellung erneut ablegen
      var saved = readSavedDesigns(fpd);
      var json = JSON.stringify(product);
      if (saved.some(function (s) { return JSON.stringify(s.product) === json; })) return;

      var shopifyProduct = FPD.productPage && FPD.productPage._shopifyProduct;
      var view = fpd.viewInstances[0];
      var scale = Math.max(THUMBNAIL_SIZE / view.options.stageWidth, THUMBNAIL_SIZE / view.options.stageHeight);

      view.toDataURL(function (thumbnail) {
        var entry = {
          thumbnail: thumbnail,
          product: product,
          title: shopifyProduct ? shopifyProduct.title : '',
          url: location.href
        };
        try {
          var list = readSavedDesigns(fpd);
          list.push(entry);
          localStorage.setItem(fpd.container.id, JSON.stringify(list));
          module.addSavedProduct(entry);
        } catch (err) {
          console.warn('[fpd-offert] Design konnte nicht gespeichert werden', err);
        }
      }, { multiplier: scale, format: 'png', backgroundColor: 'transparent' });
    } catch (err) {
      console.warn('[fpd-offert] Automatisches Speichern fehlgeschlagen', err);
    }
  }

  function readSavedDesigns(fpd) {
    try {
      var list = JSON.parse(localStorage.getItem(fpd.container.id) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (err) {
      return [];
    }
  }

  /** Öffnet das Save-Load-Modul, sobald der Designer steht und Designs gespeichert sind. */
  function showSavedDesignsOnStart() {
    // Bearbeiten aus dem Warenkorb lädt schon ein Design
    if (new URLSearchParams(location.search).has('li-key')) return;

    var tries = 0;
    (function poll() {
      var fpd = window.FPD && FPD.instance;
      var ready = fpd && fpd.mainBar && fpd['moduleInstance_' + SAVE_LOAD_MODULE] &&
        fpd.viewInstances && fpd.viewInstances.length;
      if (!ready) {
        if (++tries < 120) setTimeout(poll, 250);
        return;
      }
      if (!fpd.mainOptions.saveActionBrowserStorage || !readSavedDesigns(fpd).length) return;
      if (fpd.viewInstances.some(function (v) { return v.fabricCanvas.isCustomized; })) return;
      fpd.mainBar.callModule(SAVE_LOAD_MODULE);
    })();
  }

  function insertButton() {
    var bar = document.querySelector('.fpd-modal-product-designer fpd-actions-bar [data-pos="modal"]');
    if (!bar || bar.querySelector('.fpd-offert-btn')) return;

    var btn = document.createElement('span');
    btn.className = 'fpd-btn fpd-offert-btn';
    btn.setAttribute('role', 'button');
    btn.innerHTML = '<span class="fpd-label">' + BUTTON_LABEL + '</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      requestQuote(btn);
    });
    // direkt hinter "Done", vor dem Schließen-X
    var done = bar.querySelector('.fpd-done');
    bar.insertBefore(btn, done ? done.nextSibling : null);
  }

  function requestQuote(btn) {
    var page = window.FPD && FPD.productPage;
    var product = page && page._shopifyProduct;
    if (!product || !FPD.instance || btn.classList.contains(BLOCKED_CLASS)) return;

    btn.classList.add('is-busy');
    autoSaveDesign();
    var params = quoteParams(page, product);

    exportDesign(FPD.instance, function (dataUrl) {
      if (dataUrl) {
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
            handle: product.handle,
            name: 'design-' + product.handle + (dataUrl.indexOf('image/jpeg') !== -1 ? '.jpg' : '.png'),
            dataUrl: dataUrl,
            createdAt: Date.now()
          }));
        } catch (err) {
          console.warn('[fpd-offert] Design konnte nicht zwischengespeichert werden', err);
        }
      }
      location.href = OFFERT_PATH + '?' + params.toString();
    });
  }

  function quoteParams(page, product) {
    var colorIdx = optionIndex(product, COLOR_OPTION);
    var sizeIdx = optionIndex(product, SIZE_OPTION);
    var quantities = (page._bulkOrderModuleState && page._bulkOrderModuleState.quantities) || {};

    var lines = [];
    product.variants.forEach(function (v) {
      var qty = parseInt(quantities[v.id], 10);
      if (qty > 0) lines.push({ variant: v, qty: qty });
    });

    // Ohne Mengen im Bulk-Order-Modul: die gerade gewählte Variante, Menge trägt der Kunde im Formular ein
    var firstVariant = lines.length ? lines[0].variant : currentVariant(page, product);
    var colors = unique(lines.map(function (l) { return optionValue(l.variant, colorIdx); }));
    var multiColor = colors.length > 1;

    // sizes-Format der Offert-Seite: "XS:3,M:5". Bei mehreren Farben trägt der
    // Schlüssel die Farbe mit, weil die Seite nur eine Farbe pro Produkt kennt.
    var sizes = lines.map(function (l) {
      var size = optionValue(l.variant, sizeIdx) || l.variant.title;
      var key = multiColor ? optionValue(l.variant, colorIdx) + ' ' + size : size;
      return clean(key) + ':' + l.qty;
    });
    var total = lines.reduce(function (sum, l) { return sum + l.qty; }, 0);

    var params = new URLSearchParams();
    params.set('product', product.handle);
    params.set('title', product.title);
    if (firstVariant && firstVariant.sku) params.set('sku', firstVariant.sku);
    var color = multiColor ? colors.join(', ') : optionValue(firstVariant, colorIdx);
    if (color) params.set('color', color);
    if (total) params.set('qty', String(total));
    if (sizes.length) params.set('sizes', sizes.join(','));
    var img = variantImage(firstVariant) || product.featured_image;
    if (img) params.set('img', absoluteUrl(img));
    // Eine Karte pro Farbe - nur ein angepasstes Offert-Template liest das,
    // das alte fällt auf color/sizes oben zurück
    if (multiColor) params.set('items', JSON.stringify(colorItems(lines, colorIdx, sizeIdx)));
    return params;
  }

  function colorItems(lines, colorIdx, sizeIdx) {
    var byColor = {};
    var items = [];
    lines.forEach(function (l) {
      var color = optionValue(l.variant, colorIdx);
      var item = byColor[color];
      if (!item) {
        var img = variantImage(l.variant);
        item = byColor[color] = { color: color, sku: l.variant.sku || '', img: img ? absoluteUrl(img) : '', qtyBySize: {} };
        items.push(item);
      }
      var size = clean(optionValue(l.variant, sizeIdx) || l.variant.title);
      item.qtyBySize[size] = (item.qtyBySize[size] || 0) + l.qty;
    });
    return items;
  }

  function currentVariant(page, product) {
    var selected = page._currentShopifyVariant;
    if (selected && selected.id) return selected;
    var id = new URLSearchParams(location.search).get('variant');
    return product.variants.filter(function (v) { return String(v.id) === id; })[0] || product.variants[0];
  }

  function optionIndex(product, pattern) {
    var names = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    for (var i = 0; i < names.length; i++) if (pattern.test(names[i])) return i;
    return -1;
  }

  function optionValue(variant, idx) {
    return variant && idx > -1 && variant.options ? variant.options[idx] : '';
  }

  function variantImage(variant) {
    return variant && variant.featured_image && variant.featured_image.src;
  }

  function absoluteUrl(src) {
    return new URL(src, location.origin).href;
  }

  function clean(s) {
    return String(s).replace(/[:,]/g, ' ').trim();
  }

  function unique(list) {
    return list.filter(function (v, i) { return v && list.indexOf(v) === i; });
  }

  /** Alle Ansichten untereinander in einem Bild - dasselbe wie "Download" im Designer. */
  function exportDesign(fpd, done) {
    var finished = false;
    var restorePrintingBoxes = hidePrintingBoxes(fpd);
    var finish = function (dataUrl) {
      if (finished) return;
      finished = true;
      restorePrintingBoxes();
      done(dataUrl);
    };
    setTimeout(function () { finish(null); }, 15000);

    try {
      fpd.getProductDataURL(function (dataUrl) {
        if (!dataUrl || dataUrl.length <= MAX_DATAURL_LENGTH) return finish(dataUrl);
        shrink(dataUrl, finish);
      }, { format: 'png' });
    } catch (err) {
      console.warn('[fpd-offert] Export fehlgeschlagen', err);
      finish(null);
    }
  }

  /** Roten Druckbereich-Rahmen aller Ansichten fürs Mockup ausblenden; gibt die Rücknahme zurück. */
  function hidePrintingBoxes(fpd) {
    var hidden = [];
    (fpd.viewInstances || []).forEach(function (view) {
      var canvas = view.fabricCanvas;
      var box = canvas && canvas.printingBoxObject;
      if (box && box.visible) {
        box.visible = false;
        hidden.push({ canvas: canvas, box: box });
      }
    });
    return function () {
      hidden.forEach(function (h) {
        h.box.visible = true;
        h.canvas.requestRenderAll();
      });
    };
  }

  function shrink(dataUrl, done) {
    var img = new Image();
    img.onload = function () {
      var scale = Math.min(1, 2000 / Math.max(img.width, img.height));
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      done(canvas.toDataURL('image/jpeg', 0.85));
    };
    img.onerror = function () { done(null); };
    img.src = dataUrl;
  }

  /* ---------------- Offert-Seite ---------------- */

  function attachDesignToOffert() {
    var stored;
    try { stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { stored = null; }
    if (!stored || !stored.dataUrl) return;

    var handle = new URLSearchParams(location.search).get('product');
    if (stored.handle !== handle || Date.now() - stored.createdAt > MAX_AGE_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    waitFor(function () {
      return document.querySelector('#quote-placements input[data-placement="mockup"]');
    }, function (checkbox) {
      var row = checkbox.closest('label').parentElement;
      var input = row && row.querySelector('input[type="file"]');
      if (!input) return;

      var dt = new DataTransfer();
      dt.items.add(dataUrlToFile(stored.dataUrl, stored.name));
      input.files = dt.files;
      // der change-Handler der Offert-Seite hakt die Zeile an und lädt die Datei hoch
      input.dispatchEvent(new Event('change', { bubbles: true }));
      sessionStorage.removeItem(STORAGE_KEY);
    });
  }

  function waitFor(find, then) {
    var tries = 0;
    (function poll() {
      var el = find();
      if (el) return then(el);
      if (++tries < 50) setTimeout(poll, 200);
    })();
  }

  function dataUrlToFile(dataUrl, name) {
    var parts = dataUrl.split(',');
    var mime = parts[0].match(/:(.*?);/)[1];
    var bin = atob(parts[1]);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new File([bytes], name, { type: mime });
  }
})();
